import { Mapping, ToWrite } from "../../src/components/flowchart/utils/toolsPublicDispatchAndReceiveMappings"

export default function ManageDispatch(props = new Array) {
  try 
  {
    // Declarar todos os elementos necessários
    let moagem = new Mapping("cr|1_1|Atributos|W", props)
  
    // Realizar todas as análises necessárias

    // Escreve todos os mapeamentos na estrutura
    ToWrite([
      moagem
    ], "ManageDispatch", props)
  }
  catch(e)
  {
    throw ("Public.ManageDispatch", e)
  }
}